import { render, staticRenderFns } from "./EditGlobalBlockModal.vue?vue&type=template&id=4d88d2c0&"
import script from "./EditGlobalBlockModal.vue?vue&type=script&lang=ts&"
export * from "./EditGlobalBlockModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports